/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'THE_FACILITY_DRAFTED__OR_MAINTAINED_AN_EXISTING__STRATEGY_POLIC',
              'FACILITY_WORKERS_AND_LOCAL_CIVIL_SOCIETY_GROUPS_WERE_ENGAGED_IN',
              'THE_FACILITY_WAS_INVOLVED_DIRECTLY_OR_THROUGH_PARTNERSHIPS_IN_E',
              'OTHER',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    did_the_fac_participate_in_any_of_the_following_activities_rela_2: valueSchema,
  },
}
